export default __webpack_public_path__ + "media/images/mailer/logo_full-3da06e7843c97161b0cf975ebd56123b.png";